import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=cdbd56fa&scoped=true"
import script from "./AppToolbar.vue?vue&type=script&lang=js"
export * from "./AppToolbar.vue?vue&type=script&lang=js"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=cdbd56fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbd56fa",
  null
  
)

export default component.exports